import { Icon } from "semantic-ui-react";

const ContactWebLinkIcon = (props) => {
  return <Icon {...props} name="alternate external" link />;
};

export default ContactWebLinkIcon;
